import styled, { css } from 'styled-components'
import { rem } from '../../utils/common'
import { device, merchantThemes } from '../Variable'

export const MessageCookieOffWrapper = styled.div`
	display: block;
	text-align: center;
	padding: ${rem(100, 25, 130, 25)};
	background: ${({ theme }) => theme.color.secondary};
	margin-top: ${rem(25)};
	border-radius: ${rem(10)};
	box-shadow: 0 ${rem(1)} ${rem(4)} 0
		${({ theme }) => theme.color.grayNineteen};

	@media (${device.mobileM}) {
		padding: ${rem(60, 10, 60, 10)};
	}
`
export const MessageCookieOffDescription = styled.div`
	display: block;
	margin: ${rem(0, 0, 30, 0)};
	font-size: ${rem(18)};
	font-weight: 600;

	${(p) =>
		p.theme.name === merchantThemes.toteme &&
		css`
			font-size: ${rem(15)};
		`}

	@media (${device.mobileM}) {
		font-size: ${rem(14)};

		${(p) =>
			p.theme.name === merchantThemes.toteme &&
			css`
				font-size: ${rem(15)};
			`}
	}
`
export const MessageCookieOffSubDescription = styled.div`
	display: block;
	font-size: ${rem(15)};

	@media (${device.mobileM}) {
		font-size: ${rem(11)};
	}
`
